export const EvaluationSkillDirectory = {
    path: '/evaluation_skill_directories',
    name: 'evaluation_skill_directories',
    component: () => import('@/views/Evaluation/Skill/Directory/EvaluationSkillDirectoryPage.vue'),
    children: [
        {
            path: '/evaluation_skill_directories/add',
            name: 'evaluation_skill_directories.add',
            component: () => import('@/views/Evaluation/Skill/Directory/Form/EvaluationSkillDirectoryForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/evaluation_skill_directories/edit/:id',
            name: 'evaluation_skill_directories.edit',
            component: () => import('@/views/Evaluation/Skill/Directory/Form/EvaluationSkillDirectoryForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/evaluation_skill_directories/delete/:id',
            name: 'evaluation_skill_directories.delete',
            component: () => import('@/views/Evaluation/Skill/Directory/Form/EvaluationSkillDirectoryForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/evaluation_skill_directories/view/:id',
            name: 'evaluation_skill_directories.view',
            component: () => import('@/views/Evaluation/Skill/Directory/Form/EvaluationSkillDirectoryForm.vue'),
            props: {viewAction: true}
        },
    ]
}